module.exports = __webpack_public_path__ + "images/shanxi_banner02.jpg?22866d36acfb9bc07e45d094c804666c";


//////////////////
// WEBPACK FOOTER
// ./src/images/active/shanxi_banner02.jpg
// module id = 190
// module chunks = 1